import ouiDom from '@goldwasserexchange/oui-dom';
import { useAtomValue } from 'jotai';
import { useSanityNewsByUrlId } from '../../../../../../../../sanity';
import { ValidSections, pathnameUrlLanguageAtom } from '../../../../../../../../history';

export const ArticleLanguageRedirect = () => {
  const locale = useAtomValue(pathnameUrlLanguageAtom);
  const {
    data,
  } = useSanityNewsByUrlId();
  const history = ouiDom.A.useHistory();
  if (!data || data.language === locale) {
    return null;
  }
  const alternateSlug = data?.translations?.find((translation) => translation.language === locale)?.slug;
  history.replace(`/${locale}/${ValidSections.NEWS}${alternateSlug != null ? `/${alternateSlug}` : ''}`);
  return null;
};
